import { render, staticRenderFns } from "./addPlayer.vue?vue&type=template&id=1a366bce&scoped=true&"
import script from "./addPlayer.vue?vue&type=script&lang=js&"
export * from "./addPlayer.vue?vue&type=script&lang=js&"
import style0 from "./addPlayer.vue?vue&type=style&index=0&id=1a366bce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a366bce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a366bce')) {
      api.createRecord('1a366bce', component.options)
    } else {
      api.reload('1a366bce', component.options)
    }
    module.hot.accept("./addPlayer.vue?vue&type=template&id=1a366bce&scoped=true&", function () {
      api.rerender('1a366bce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/tianjiaoScoreManagement/components/addPlayer.vue"
export default component.exports